
import { useEffect, useRef } from "react";
import { WebPImage } from "../ui/WebPImage";

// Called on mount, only once per ad
function useImpression(adId: string) {
  const trackedRef = useRef(false);
  useEffect(() => {
    if (trackedRef.current) return;
    trackedRef.current = true;
    fetch(
      "https://nartcbzfahbmkgsysyur.functions.supabase.co/track-ad-impression",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ad_type: "banner", ad_id: adId }),
      }
    ).catch((e) => {
      // Impressions are best effort, don't block rendering
      console.error("Ad impression tracking failed", e);
    });
  }, [adId]);
}

type BannerItemProps = {
  id: string;
  image_url: string;
  alt_text?: string | null;
  target_url?: string | null;
};

export default function BannerItem({ id, image_url, alt_text, target_url }: BannerItemProps) {
  useImpression(id);

  // Track click
  async function trackBannerClick(adId: string) {
    try {
      await fetch(
        "https://nartcbzfahbmkgsysyur.functions.supabase.co/track-ad-click",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ad_type: "banner", ad_id: adId }),
        }
      );
    } catch (e) {
      // Tracking errors are non-blocking
      console.error("Ad click tracking failed", e);
    }
  }

  return (
    <a
      href={target_url || "#"}
      target="_blank"
      rel="noopener noreferrer"
      className="block transition-shadow shadow-md hover:shadow-lg rounded overflow-hidden max-w-full"
      style={{ minWidth: 240, maxWidth: 400 }}
      onClick={() => trackBannerClick(id)}
    >
      <WebPImage
        src={image_url}
        alt={alt_text || "Banner Ad"}
        className="w-full h-24 md:h-32 object-cover block"
        loading="lazy"
        width={400}
        height={128}
        mode="thumbnail"
        useCloudflare={true}
      />
    </a>
  );
}
